import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { PeopleService, LanguageService } from '../shared/services';
import { Observable } from 'rxjs';

@Injectable()
export class TranslateResolver {
  constructor(private people: PeopleService, private language: LanguageService) {}

  resolve(): Observable<any> {
    return this.language.loadTranslations('en').pipe(map((translation) => translation));
  }
}
